/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CurrencyDto, List1Params } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiCurrencyController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-currency-controller
   * @name List1
   * @request GET:/api/v1/currencies
   */
  list = (query: List1Params, params: RequestParams = {}) =>
    this.http.request<CurrencyDto[], any>({
      path: `/v1/currencies`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static listPath = '/v1/currencies'
  static listMethod = 'GET'
}
